import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NbCalendarRange, NbThemeService } from "@nebular/theme";
import { LenguageService } from "../../../@core/utils/lenguage.service";
import { StatisticService } from "../../../@core/api/statistics.service";
import { CampaignProjectService } from "../../../@core/api/campaign-project.service";
import { Campaign } from "../../../@core/data/campaign";

@Component({
  selector: "ngx-projects-campaign-statistics",
  templateUrl: "./projects-campaign-statistics.component.html",
  styleUrls: ["./projects-campaign-statistics.component.scss"],
})
export class ProjectsCampaignStatisticsComponent implements OnInit {
  id: string;
  campaign: Campaign;

  loading: boolean = true;
  timeFrame: string = "today";
  leadTime: string = "time";
  timeRange: {
    dateStart: number;
    dateEnd: number;
  };
  dateRange: NbCalendarRange<Date>;
  dataTotal: any;
  dailyOffers: any = [];
  dailyRefs: any = [];
  dailyCampaign: any = [];

  dailyOffersData: any = [];
  dailyRefsData: any = [];
  dailyCampaignData: any = [];

  totalOffersData: any = [];
  totalRefsData: any = [];
  totalCampaignData: any = [];

  chartOffers: any;
  chartRefs: any;
  chartCampaign: any;
  themeSubscription: any;
  showLegend = true;
  showXAxis = true;
  showYAxis = true;
  showXAxisLabel = true;
  xAxisLabel = "Data";
  showYAxisLabel = true;
  yAxisLabel = "Population";
  colorScheme: any;
  campaingsMap = {};

  constructor(
    public language: LenguageService,
    private theme: NbThemeService,
    public statisticService: StatisticService,
    public route: ActivatedRoute,
    public campaignService: CampaignProjectService
  ) {
    this.id = this.route.snapshot.params["id"];
    this.themeSubscription = this.theme.getJsTheme().subscribe((config) => {
      const colors: any = config.variables;
      this.colorScheme = {
        domain: [
          colors.primaryLight,
          colors.successLight,
          colors.warningLight,
          colors.dangerLight,
          colors.infoLight,
        ],
      };
    });
  }

  async ngOnInit() {
    this.getDataCampaign();
  }

  async getDataCampaign() {
    if (this.id) {
      this.campaign = await this.campaignService.getCampaign(this.id);
      this.id = this.campaign.offer_id;
      this.campaingsMap[this.id] = this.campaign.name;
    } else {
      let campaigns = <Campaign[]>await this.campaignService.getCampaigns(
        {
          perPage: 1000,
          pageNumber: 0,
        },
        undefined,
        {
          field: "timestamp",
          direction: "desc",
        }
      );

      campaigns.map((c) => {
        this.campaingsMap[c.offer_id] = c.name;
      });
    }
    this.timeChanged();
  }

  refreshData(){
    if (this.timeFrame !== "personalized") {
      this.timeChanged();
    } else {
      this.rangeChanged();
    }
  }

  rangeChanged() {
    if (this.dateRange.end && this.dateRange.start) {
      let dateEnd =
        new Date(this.dateRange.end).getTime() + 24 * 60 * 60 * 1000;
      let dateStart = (new Date(this.dateRange.start).getTime() * 1000) / 1000;

      dateStart += 1000 * 60 * 60;
      dateEnd += 1000 * 60 * 60;
      this.getData(dateStart, dateEnd);
    }
  }

  timeChanged() {
    let interval = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
    let dateStart = Math.floor(Date.now() / interval) * interval;
    let dateEnd = Date.now();
    this.timeRange = { dateStart, dateEnd };

    switch (this.timeFrame) {
      case "today":
        interval = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
        dateStart = Math.floor(Date.now() / interval) * interval;
        dateEnd = Date.now();
        this.timeRange = { dateStart, dateEnd };

        break;

      case "yesterday":
        interval = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
        dateStart = Math.floor(Date.now() / interval) * interval - interval;
        dateEnd = Math.floor(Date.now() / interval) * interval;

        this.timeRange = { dateStart, dateEnd };

        break;

      case "week":
        let d = new Date();
        let day = d.getDay();
        let diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        d.setDate(diff);
        dateStart = d.getTime();
        dateEnd = Date.now();
        dateStart += 1000 * 60 * 60;
        dateEnd += 1000 * 60 * 60;
        this.timeRange = { dateStart, dateEnd };

        break;

      case "month":
        let currentDate = new Date();
        dateEnd = Date.now();
        dateStart =
          (new Date(
            currentDate.getMonth() +
              1 +
              "-1-" +
              currentDate.getFullYear() +
              " 00:00"
          ).getTime() *
            1000) /
          1000;
        dateStart += 1000 * 60 * 60;
        dateEnd += 1000 * 60 * 60;
        this.timeRange = { dateStart, dateEnd };

        break;

      default:
        break;
    }

    if (this.timeFrame !== "personalized") {
      this.getData(dateStart, dateEnd);
    }
  }

  async getData(dateStart, dateEnd) {
    this.loading = true;

    if (this.id) {
      this.dailyTotalOfferElaborate(
        await this.statisticService.getDayLeadsOfferId(
          dateStart,
          dateEnd,
          this.id,
          this.leadTime
        )
      );

      this.dailyTotalRefElaborate(
        await this.statisticService.getDayLeadsRefId(
          dateStart,
          dateEnd,
          this.id,
          this.leadTime
        )
      );

      this.dailyTotalCampaignElaborate(
        await this.statisticService.getDayLeadsCampaignId(
          dateStart,
          dateEnd,
          this.id,
          this.leadTime
        )
      );

      this.dataTotal = <any>(
        await this.statisticService.getTotalLeadsId(dateStart, dateEnd, this.id, this.leadTime)
      );

      this.totalOfferElaborate(
        await this.statisticService.getTotalLeadsOfferId(
          dateStart,
          dateEnd,
          this.id,
          this.leadTime
        )
      );
      this.totalRefElaborate(
        await this.statisticService.getTotalLeadsRefId(
          dateStart,
          dateEnd,
          this.id,
          this.leadTime
        )
      );

      this.totalCampaignElaborate(
        await this.statisticService.getTotalLeadsCampaignId(
          dateStart,
          dateEnd,
          this.id,
          this.leadTime
        )
      );

    } else {

      this.dailyTotalOfferElaborate(
        await this.statisticService.getDayLeadsOffer(dateStart, dateEnd, this.leadTime)
      );

      this.dailyTotalRefElaborate(
        await this.statisticService.getDayLeadsRef(dateStart, dateEnd, this.leadTime)
      );

      this.dailyTotalCampaignElaborate(
        await this.statisticService.getDayLeadsCampaign(dateStart, dateEnd, this.leadTime)
      );

      this.dataTotal = <any>(
        await this.statisticService.getTotalLeads(dateStart, dateEnd, this.leadTime)
      );

      this.totalOfferElaborate(
        await this.statisticService.getTotalLeadsOffer(dateStart, dateEnd, this.leadTime)
      );

      this.totalRefElaborate(
        await this.statisticService.getTotalLeadsRef(dateStart, dateEnd, this.leadTime)
      );

      this.totalCampaignElaborate(
        await this.statisticService.getTotalLeadsCampaign(dateStart, dateEnd, this.leadTime)
      );
    }

    // console.log(this.dataTotal);
    this.loading = false;
  }

  async totalOfferElaborate(data) {
    this.totalOffersData = Object.keys(data).map((d) => {
      let ret = {
        key: this.campaingsMap[d] || d,
        value: data[d].total,
        sms: data[d].totalSms,
      };
      return ret;
    });
    // console.log(this.totalOffersData);
  }

  async totalRefElaborate(data) {
    this.totalRefsData = Object.keys(data).map((d) => {
      let ret = {
        key:  d,
        value: data[d].total,
        sms: data[d].totalSms,
      };
      return ret;
    });

    console.log(this.totalRefsData);
  }

  async totalCampaignElaborate(data) {
    this.totalCampaignData = Object.keys(data).map((d) => {
      let ret = {
        key:  d,
        value: data[d].total,
        sms: data[d].totalSms,
      };
      return ret;
    });

    // console.log(this.totalCampaignData);
  }

  async dailyTotalOfferElaborate(data) {
    data.map((d) => {
      this.dailyOffers.push(...Object.keys(d.data));
    });

    this.dailyOffers = [...new Set(this.dailyOffers)];
    this.dailyOffersData = data;

    let prev = {};

    data.map((day: any) => {
      this.dailyOffers.map((offer) => {
        if (prev[offer]) {
          prev[offer].series.push({
            name: day.date,
            value: day.data[offer] || 0,
          });
        } else {
          prev[offer] = {
            name: this.campaingsMap[offer] || offer,
            series: [
              {
                name: day.date,
                value: day.data[offer] || 0,
              },
            ],
          };
        }
      });
    });

    this.chartOffers = Object.keys(prev).map((k) => {
      return prev[k];
    });
  }

  async dailyTotalRefElaborate(data) {
    data.map((d) => {
      this.dailyRefs.push(...Object.keys(d.data));
    });

    this.dailyRefs = [...new Set(this.dailyRefs)];
    this.dailyRefsData = data;

    let prev = {};

    data.map((day: any) => {
      this.dailyRefs.map((offer) => {
        if (prev[offer]) {
          prev[offer].series.push({
            name: day.date,
            value: day.data[offer] || 0,
          });
        } else {
          prev[offer] = {
            name: offer,
            series: [
              {
                name: day.date,
                value: day.data[offer] || 0,
              },
            ],
          };
        }
      });
    });

    this.chartRefs = Object.keys(prev).map((k) => {
      return prev[k];
    });
  }

  async dailyTotalCampaignElaborate(data) {
    data.map((d) => {
      this.dailyCampaign.push(...Object.keys(d.data));
    });

    this.dailyCampaign = [...new Set(this.dailyRefs)];
    this.dailyCampaignData = data;

    let prev = {};

    data.map((day: any) => {
      this.dailyRefs.map((offer) => {
        if (prev[offer]) {
          prev[offer].series.push({
            name: day.date,
            value: day.data[offer] || 0,
          });
        } else {
          prev[offer] = {
            name: offer,
            series: [
              {
                name: day.date,
                value: day.data[offer] || 0,
              },
            ],
          };
        }
      });
    });

    this.chartCampaign = Object.keys(prev).map((k) => {
      return prev[k];
    });
  }
}
